import React from "react";
import { useState } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";
import { Translate } from "../../../Enums/Tranlate";
import CardItem from "./CardItem";
import AddBookingModal from "./AddBookingModal";
import BookingService from "../../../../services/BookingService";

const AllBooking = () => {
	const [data, setData] = useState([]);
	const [hasData, setHasData] = useState(null);
	const [addModal, setAddModal] = useState(false);
	const [item, setItem] = useState({});
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const bookingService = new BookingService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const search = useSelector((state) => state.auth.search);

	return (
		<div className="department">
			<div className="mb-4">
				<div className="search-card d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang].booking}
						</span>
					</div>
					<div className="add-admin">
						{isExist("add_all_booking") && (
							<Button
								variant="primary"
								className="me-2 h-75"
								onClick={() => {
									setItem({});
									setAddModal(true);
								}}>
								<i
									className={`la la-plus ${
										lang === "en" ? "mr-2" : "ml-2"
									}`}></i>
								{Translate[lang]?.add} {Translate[lang]?.booking}
							</Button>
						)}
					</div>
				</div>
			</div>

			<Row>
				<Col lg={12}>
					<Card>
						<div
							className={`${hasData === 0 ? "text-center" : "table-style"} `}>
							{loading && (
								<div style={{ height: "400px" }}>
									<Loader />
								</div>
							)}

							{hasData === 1 && !loading && (
								<Table responsive>
									<thead>
										<tr className="text-center">
											<th>
												<strong>{Translate[lang]?.court}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.date}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.time}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.phone}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.booking}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.action}</strong>
											</th>
										</tr>
									</thead>

									<tbody className="table-body">
										{data?.map((item, index) => {
											return (
												<CardItem
													index={index}
													setShouldUpdate={setShouldUpdate}
													key={index}
													item={item}
													setAddModal={setAddModal}
													setItem={setItem}
												/>
											);
										})}
									</tbody>
								</Table>
							)}
							{hasData === 0 && <NoData />}
							<Pagination
								setData={setData}
								service={bookingService}
								shouldUpdate={shouldUpdate}
								setHasData={setHasData}
								setLoading={setLoading}
								search={search}
							/>
						</div>
					</Card>
				</Col>
			</Row>
			{addModal && (
				<AddBookingModal
					addModal={addModal}
					setShouldUpdate={setShouldUpdate}
					setAddModal={() => setAddModal(false)}
					item={item}
				/>
			)}
		</div>
	);
};

export default AllBooking;
